import { z } from 'zod';
import { legalClientFullObjectSchema } from '../ILegalClient';

export const LegalTransactionRelationshipMemberBaseSchema = z.object({
  FirstName: z.string().nullable(),
  LastName: z.string(),
  LegalClient: legalClientFullObjectSchema,
  RelationshipRole: z.string().nullable().optional(),
  idLegalClient: z.number(),
  idLegalClientRelationship: z.number(),
  idRelationship: z.number(),
  isActiveLegalClientRelationship: z.boolean(),
  Joined_At: z.string().nullable().optional(),
  Last_Update: z.string().nullable().optional(),
});

export type ILegalTransactionRelationshipMemberBase = z.infer<
  typeof LegalTransactionRelationshipMemberBaseSchema
>;

export function GenericLegalTransactionRelationshipMemberSchema<
  TRole extends z.ZodTypeAny,
  TData extends z.ZodTypeAny,
>(role: TRole, data: TData) {
  return LegalTransactionRelationshipMemberBaseSchema.extend({
    idRelationshipRole: role,
    data,
  });
}
